
export default {
    items: [
        {
            name: 'Dashboard',
            url: '/dashboard',
            icon: 'fa-solid fa-home-heart',
            roles: ['all'],
        },
        {
            name: 'Search',
            url: '/search',
            icon: 'fa-solid fa-search',
            roles: ['all'],
        },
        // {
        //     name: 'Compliance Flags',
        //     url: '/flags/compliance',
        //     icon: 'fa-solid fa-file-contract',
        //     roles: ['Compliance Admin', 'Operations Admin', 'B79 Admin', 'Super Admin'],
        // },
        {
            name: 'Fulfillment',
            url: '/fulfillment',
            icon: 'fa-solid fa-print',
            class: 'd-none',
            roles: ['Operations Admin', 'Processing Admin', 'Fulfillment Admin', 'Customer Service Admin',],
        },
        {
            name: 'Package Intake',
            url: '/intake',
            icon: 'fa-solid fa-box-circle-check',
            class: 'd-none',
            roles: ['Operations Admin', 'Processing Admin', 'Processing Diamond Appraiser', 'Processing Level 1 Appraiser', 'Compliance Admin',],
        },
        {
            name: 'Appraisal',
            url: '/appraisals',
            icon: 'fa-solid fa-box-full',
            class: 'd-none',
            roles: ['Operations Admin', 'Processing Admin', 'Processing Diamond Appraiser', 'Processing Level 1 Appraiser', 'Processing Level 2 Appraiser', 'Compliance Admin',],
        },
        {
            name: 'Quality Assurance',
            url: '/quality-assurance',
            icon: 'fa-solid fa-file-check',
            class: 'd-none',
            roles: ['Operations Admin', 'Processing Admin', 'Processing Diamond Appraiser', 'Compliance Admin',],
        },
        {
            name: 'Kit View',
            url: '/kit/view',
            icon: 'fa-solid fa-list-alt',
            class: 'd-none',
            roles: ['Operations Admin', 'Processing Admin', 'Admin Read Only', 'Processing Diamond Appraiser', 'Processing Level 1 Appraiser', 'Processing Level 2 Appraiser', 'Customer Service Admin', 'Customer Service Lead', 'Customer Service Email Specialist', 'Customer Service Level 1', 'Customer Service Level 2', 'Inventory Management Admin', 'Inventory Management Level 1', 'Accounting Admin', 'Accounting Level 1', 'Compliance Admin',],
        },
        {
            name: 'Offer Generation',
            url: '/offer-generation',
            icon: 'fa-solid fa-file-invoice-dollar',
            class: 'd-none',
            roles: ['Operations Admin', 'Processing Admin', 'Processing Diamond Appraiser', 'Compliance Admin',],
        },
        {
            name: 'Payments',
            url: '/payments',
            icon: 'fa-solid fa-money-bill-alt',
            class: 'd-none',
            roles: ['Accounting Admin', 'Accounting Level 1',],
        },
        {
            name: 'Inventory Management',
            url: '/inventory',
            icon: 'fa-solid fa-boxes',
            class: 'd-none',
            roles: ['Inventory Management Admin', 'Inventory Management Level 1', 'Compliance Admin',],
        },
        {
            name: 'Returns',
            url: '/returns',
            icon: 'fa-solid fa-share',
            class: 'd-none',
            roles: ['Operations Admin', 'Processing Admin', 'Processing Diamond Appraiser', 'Processing Level 1 Appraiser', 'Processing Level 2 Appraiser',],
        },
        {
            name: 'Batch',
            url: '/batch',
            icon: 'fa-solid fa-industry',
            class: 'd-none',
            roles: ['Inventory Management Admin', 'Inventory Management Level 1', 'Accounting Admin',],
        },
        {
            name: 'Reports',
            url: '/reports',
            icon: 'fa-solid fa-bar-chart',
            roles: ['Super Admin', 'B79 Admin', 'Admin Read Only','Accounting Admin', 'Operations Admin', 'Compliance Admin', 'Customer Service Admin', 'Customer Service Lead', 'Processing Admin',],
        },
        {
            name: 'Knowledge Base',
            url: 'https://knowledge.admin.apigx.com/',
            icon: 'fa-solid fa-question',
            class: 'mt-auto d-none',
            attributes: {
                target: '_blank'
            },
            roles: ['Operations Admin', 'Customer Service Admin', 'Customer Service Lead', 'Customer Service Email Specialist', 'Customer Service Level 1', 'Customer Service Level 2',],

        },
        {
            name: 'Pricing',
            url: '/pricing',
            icon: 'fa-solid fa-dollar-sign',
            class: 'd-none',
            roles: ['Super Admin', 'B79 Admin', 'Pricing Admin', 'Admin Read Only',],

        },
        {
            name: 'Admin Tools',
            url: '/admin-tools',
            icon: 'fa-solid fa-hammer',
            class: 'd-none',
            roles: ['Super Admin',],

        },
        {
            name: 'Settings',
            url: '/settings',
            icon: 'fa-solid fa-cog',
            class: 'd-none',
            roles: [],
        },
    ],
};
